/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 14:30:21
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getDBManagementDetailAsync,
  getDBManagementSubmitAsync,
} from './disqualificationBreakageManagementSlice'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import { ItemCompletionType } from '../../completion/completionSlice'
import { SupplierModal } from '../../savebusiness/modal'
import styles from './disqualificationBreakageManagement.module.css'
import { getUserList } from '../../user/userSlice'
import { selectUserId } from '../../../app/applicationSlice'

const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?:any
  isEdit?:any
  lookFlag?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const userId = useSelector(selectUserId)

  const dispatch = useDispatch<RootDispatch>()

  const [selectData, setSelectData] = useState<any>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [userList, setUserList] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  const getDetail = () => {
    dispatch(getDBManagementDetailAsync({
      id: props?.id,
      tenantId: props?.editTenantId,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        setSelectData({ ...v, name: v?.tenantMaterialsName,id:v?.tenantInventoryLedgerId})
        form.setFieldsValue({
          ...v,
          reportLossUser:
            v?.reportLossUser && v?.reportLossUser != -1
              ? v?.reportLossUser?.toString()
              : undefined,
          periodValidity: v?.periodValidity
            ? moment(v?.periodValidity)
            : undefined,
          reportLossDate: v?.reportLossDate
            ? moment(v?.reportLossDate)
            : undefined,
          reportLossPrice:
            v?.reportLossPrice > 0 ? v?.reportLossPrice?.toFixed(2) : undefined,
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        form.setFieldsValue({
          reportLossUser: userId?.toString(),
        })
      }
    } else {
      form.resetFields()
      setSelectData('')
      setDetail({})
      setUserList([])
    }
  }, [props.isModalVisible])

  return (
    <>
      <Modal
        width={1000}
        title={props?.isEdit == '0' ? '查看详情' : props?.lookFlag ? '查看' : props?.id ? '编辑数据' : '添加数据'}
        visible={props.isModalVisible}
        footer={null}
        className={styles.modal}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const reportLossUserName = userList?.find(
              (v: any) => v?.id == vs?.reportLossUser
            )?.name
            const reportLossDate = vs?.reportLossDate
              ? moment(vs?.reportLossDate)?.format(DateTimeFormatSimpleOnly)
              : ''

            const commonParam = {
              reportLossDate: reportLossDate,
              spec: undefined,
              originName: undefined,
              doseCategory: undefined,
              batchNo: undefined,
              unit: undefined,
              supplierName: undefined,
              periodValidity: undefined,
              reportLossPrice: undefined,
            }
            const params = props?.id
              ? {
                  ...vs,
                  ...commonParam,
                  id: detail?.id,
                  tenantMaterialsCatalogId:
                    selectData?.tenantMaterialsCatalogId ||
                    detail?.tenantMaterialsCatalogId,
                  tenantInventoryLedgerId: selectData?.id,
                  reportLossUserName:
                    reportLossUserName || detail?.reportLossUserName,
                }
              : {
                  ...vs,
                  ...commonParam,
                  tenantMaterialsCatalogId:
                    selectData?.tenantMaterialsCatalogId,
                  tenantInventoryLedgerId: selectData?.id,
                  reportLossUserName: reportLossUserName,
                }
            if (vs?.reportLossNumber > selectData?.count) {
              setConfirmLoading(false)
              notification?.info({
                message: '报损数量要小于等于对应药品批次的数量',
              })
              return
            }
            if (vs?.tenantMaterialsName == selectData?.name) {
              dispatch(getDBManagementSubmitAsync({ ...params }))
                .then(unwrapResult)
                .then((v: any) => {
                  notification.success({
                    message: '操作成功',
                  })
                })
                .finally(() => {
                  props?.onOk()
                  setConfirmLoading(false)
                })
            } else {
              notification.info({
                message: '商品名称错误，请修改后再保存',
              })
              setConfirmLoading(false)
            }
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='商品名'
                name='tenantMaterialsName'
                rules={[
                  {
                    required: true,
                    message: '商品名不能为空',
                  },
                ]}
              >
                <RecipeItemInput
                  disabled={props?.lookFlag}
                  noSetting={true}
                  type={ItemCompletionType.Auto}
                  filters={false}
                  useSpecifiedBatch={true}
                  onSelect={(v: any) => {
                    setSelectData(v)
                    form.setFieldsValue({
                      tenantMaterialsName: v?.name,
                      spec: v?.spec,
                      originName: v?.tenantSupplierName,
                      doseCategory: v?.doseCategory,
                      batchNo: v?.batchNo,
                      unit: v?.accountUnit,
                      supplierName: v?.gysName,
                      periodValidity: v?.deadline ? moment(v?.deadline) : '',
                      reportLossPrice:
                        v?.retailPrice > 0 ? v?.retailPrice?.toFixed(2) : '',
                    })
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='规格' name='spec'>
                <Input placeholder='规格' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='厂家' name='originName'>
                <Input placeholder='厂家' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='剂型' name='doseCategory'>
                <Input placeholder='剂型' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='批号' name='batchNo'>
                <Input placeholder='批号' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='单位' name='unit'>
                <Input placeholder='单位' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} name='supplierName' label='供应商'>
                <Input placeholder='供应商' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='有效期' name='periodValidity'>
                <DatePicker
                  disabled
                  style={{ width: '100%' }}
                  placeholder='有效期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='报损数量'
                name='reportLossNumber'
                rules={[
                  {
                    required: true,
                    message: '报损数量不能为空',
                  },
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='报损数量' disabled={props?.lookFlag} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='报损金额' name='reportLossPrice'>
                <Input placeholder='报损金额' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='报损原因' name='reportLossReason'>
                <Input placeholder='报损原因' disabled={props?.lookFlag} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='报损日期'
                name='reportLossDate'
                rules={[
                  {
                    required: true,
                    message: '报损日期不能为空',
                  },
                ]}
              >
                <DatePicker
                  disabled={props?.lookFlag}
                  style={{ width: '100%' }}
                  placeholder='报损日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='报损人' name='reportLossUser'>
                <Select
                  placeholder='报损人'
                  allowClear
                  disabled={props?.lookFlag}
                >
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='处理意见' name='handleSuggestion'>
                <Input placeholder='处理意见' disabled={props?.lookFlag} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='处理结果' name='handleResult'>
                <Input placeholder='处理结果' disabled={props?.lookFlag} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' disabled={props?.lookFlag} />
              </Form.Item>
            </Col>
          </Row>
          {props?.lookFlag || props?.isEdit == '0' ? (
            <></>
          ) : (
            <>
              <Row
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  loading={confirmLoading}
                  type='primary'
                  onClick={() => {
                    form.submit()
                  }}
                  style={{ marginRight: '10px' }}
                >
                  确定
                </Button>
                <Button
                  type='primary'
                  ghost
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    props?.onCancel()
                  }}
                >
                  取消
                </Button>
              </Row>
            </>
          )}
        </Form>
      </Modal>
    </>
  )
}
